import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {MGiftVoucherPriceCategory} from "../model/m-gift-voucher-price-category";
import {AppSettings} from '../../../settings/app-settings';

@Injectable()
export class MGiftvoucherPriceCategoryService {

  constructor(private http: HttpClient) {
  }

  public findAll(): Observable<MGiftVoucherPriceCategory[]> {
    return this.http.get<MGiftVoucherPriceCategory[]>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/master-files/m-gift-voucher-price-category/find-all");
  }

  public save(mGiftVoucherPriceCategory: MGiftVoucherPriceCategory): Observable<MGiftVoucherPriceCategory> {
    return this.http.post<MGiftVoucherPriceCategory>(AppSettings.API_ENDPOINT + "/api/v1/gflock-main-service/master-files/m-gift-voucher-price-category/save", mGiftVoucherPriceCategory);
  }

  public delete(indexNo: number): Observable<number> {
    return this.http.delete<number>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-gift-voucher-price-category/delete/' + indexNo);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher-price-category/service/m-gift-voucher-price-category.service.ts